export const ApprovalTabData = [
    {
        title: 'Semua',
        cname: 'all'
    },
    {
        title: 'Kartu Baru',
        cname: 'new'
    },
    {
        title: 'Kartu Hilang',
        cname: 'lost'
    },
    {
        title: 'Kartu Rusak',
        cname: 'broke'
    },
];